import React from 'react'
import { Route } from 'react-router'
import * as Views from './views'

const Routes = <Route path="survey-archive" component={Views.SurveyArchive} />

export default Routes
